  import React, { useState } from 'react';
  import { Link } from 'react-scroll';
  import './Navbar.css';
  function Navbar() {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    return (
      <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="own" spy={true} smooth={true} offset={-100} duration={500} className="navbar-logo">
            <i class="fa-solid fa-p"></i>
            <i class="fa-solid fa-r"></i>
            <i class="fa-solid fa-microchip"></i>
            <i class="fa-solid fa-g"></i>
            <i class="fa-solid fa-d"></i>
            <i class="fa-solid fa-m"></i>
            <i class="fa-solid fa-r"></i>
          </Link>
          <div className="icon-menu" onClick={handleClick}>
              <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>

            <li className='nav-item'>
              <Link to="own" spy={true} smooth={true} offset={-80} duration={500} className='nav-links' onClick={closeMobileMenu}>
              <i class="fa-solid fa-house-user"></i>
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='hero' spy={true} smooth={true} offset={-80} duration={500} className='nav-links' onClick={closeMobileMenu}>
              <i class="fa-solid fa-address-card"></i>
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='project' spy={true} smooth={true} offset={-80} duration={500} className='nav-links' onClick={closeMobileMenu}>
              <i class="fa-solid fa-diagram-project"></i>
              </Link>
            </li>
            <li className='nav-item'>
              <Link to='contact' spy={true} smooth={true} offset={-80} duration={500} className='nav-links' onClick={closeMobileMenu}>
              <i class="fa-solid fa-envelope"></i>
              </Link>
            </li>

          </ul>
        </div>
      </nav>
      </>
    )
  }

  export default Navbar
